'use client';

import { LotterySlider as CommonLotterySlider } from '@monorepo/common';
import type { LotteryEvent } from '../../types';

interface LotterySliderProps {
  lotteryEventList: Array<LotteryEvent>;
}

function LotterySlider(props: LotterySliderProps) {
  return <CommonLotterySlider {...props} />;
}

export default LotterySlider;
